/**
 * Какой раскладкой рисовать урок: телефонной или компьютерной.
 *
 * ⚠️ В ПРИЛОЖЕНИИ НА iOS — ВСЕГДА ТЕЛЕФОННАЯ, какой бы ширины ни была страница (01.10.2026, 1.1.0 на iPhone).
 * Полноэкранный ролик кладёт интерфейс горизонтально, страница урока становилась шире 768 px, урок
 * перерисовывался компьютерной раскладкой и закрывал ролик: полный экран открывался и через секунду схлопывался.
 * С 1.1.1 корень приложения — только портрет, и ширина меняться не должна; это правило — вторая линия, от
 * оболочки не зависящая.
 *
 * iPad отдельно не разбирается: приложение собрано только для iPhone (`TARGETED_DEVICE_FAMILY = 1`), на iPad оно
 * открывается окном iPhone — страница там и так узкая. Android — по ширине, как прежде: на планшете Android
 * компьютерная раскладка остаётся. Сайт — по ширине.
 */
export function lessonPhoneLayout(o: { narrow: boolean; store: boolean; platform: string }): boolean {
  return o.narrow || (o.store && o.platform === 'ios');
}
